import { glob, EventBus } from '@fiverr-private/futile';

const KEY = Symbol.for('codeActivationTriggers_EventBus');

export const codeActivationEventBus = (glob[KEY] = glob[KEY] || new EventBus({ log: true }));
